import React from "react";
import { ArrowUp, ArrowDown, X, Plus } from "lucide-react";

export const StringListEditor = ({ value, onChange, testId }) => {
  const items = Array.isArray(value) ? value : [];
  const update = (i, v) => onChange(items.map((s, idx) => (idx === i ? v : s)));
  const move = (i, dir) => {
    const arr = [...items];
    const j = i + dir;
    if (j < 0 || j >= arr.length) return;
    [arr[i], arr[j]] = [arr[j], arr[i]];
    onChange(arr);
  };
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const add = () => onChange([...items, ""]);
  return (
    <div data-testid={testId} className="space-y-2">
      {items.map((v, i) => (
        <div key={i} className="flex items-center gap-2">
          <input
            value={v}
            onChange={(e) => update(i, e.target.value)}
            data-testid={`${testId}-item-${i}`}
            className="flex-1 bg-[#1A1A1A] border border-[#262626] rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#FF6600]"
          />
          <button type="button" onClick={() => move(i, -1)} className="w-8 h-8 rounded-lg border border-[#262626] grid place-items-center hover:border-[#FF6600]"><ArrowUp className="w-3.5 h-3.5" /></button>
          <button type="button" onClick={() => move(i, 1)} className="w-8 h-8 rounded-lg border border-[#262626] grid place-items-center hover:border-[#FF6600]"><ArrowDown className="w-3.5 h-3.5" /></button>
          <button type="button" onClick={() => remove(i)} className="w-8 h-8 rounded-lg border border-[#262626] grid place-items-center hover:border-red-500"><X className="w-3.5 h-3.5" /></button>
        </div>
      ))}
      <button type="button" onClick={add} data-testid={`${testId}-add`} className="text-xs uppercase tracking-widest text-[#FF6600] font-semibold inline-flex items-center gap-1 hover:text-white transition-colors">
        <Plus className="w-3.5 h-3.5" /> Add item
      </button>
    </div>
  );
};
